import { render, staticRenderFns } from "./GamesTable.vue?vue&type=template&id=512c6e98&"
import script from "./GamesTable.vue?vue&type=script&lang=js&"
export * from "./GamesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/workspace/is_minesweeper-flags-client_main/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VAlert,VDataTable,VProgressLinear})
